import React, { useState, useRef, useEffect } from "react";
import { Zap, Cloud, Hexagon, ChevronDown } from "react-feather";
import { AIModel } from "./ModelSelector";

interface InlineModelSelectorProps {
	selectedModel: AIModel;
	onModelSelect: (model: AIModel) => void;
	disabled?: boolean;
}

const InlineModelSelector: React.FC<InlineModelSelectorProps> = ({
	selectedModel,
	onModelSelect,
	disabled = false
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);

	const models = [
		{
			id: "claude" as AIModel,
			name: "Claude",
			icon: <Cloud size={14} />,
			color: "#7C3AED"
		},
		{
			id: "gemini" as AIModel,
			name: "Gemini",
			icon: <Zap size={14} />,
			color: "#F59E0B"
		},
		{
			id: "journey_ai" as AIModel,
			name: "Journey AI",
			icon: <Hexagon size={14} />,
			color: "#EF4444"
		}
	];

	const currentModel = models.find((m) => m.id === selectedModel) || models[0];

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isOpen]);

	const handleModelSelect = (model: AIModel) => {
		onModelSelect(model);
		setIsOpen(false);
	};

	return (
		<div className="inline-model-selector" ref={dropdownRef}>
			<button
				type="button"
				className="inline-model-button"
				onClick={() => !disabled && setIsOpen(!isOpen)}
				disabled={disabled}
			>
				<span className="model-icon">{currentModel.icon}</span>
				<span className="model-name">{currentModel.name}</span>
				<ChevronDown size={14} className="chevron-icon" />
			</button>

			{isOpen && (
				<div className="inline-model-dropdown">
					{models.map((model) => (
						<button
							key={model.id}
							type="button"
							className={`model-option ${selectedModel === model.id ? "active" : ""}`}
							onClick={() => handleModelSelect(model.id)}
						>
							<span className="model-icon" style={{ color: model.color }}>
								{model.icon}
							</span>
							<span className="model-name">{model.name}</span>
							{selectedModel === model.id && (
								<span className="check-icon">✓</span>
							)}
						</button>
					))}
				</div>
			)}
		</div>
	);
};

export default InlineModelSelector;
